import {
  IconActivityHeartbeat,
  IconCircleCheck,
  IconClockHour4,
  IconTrash,
} from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { PROJECT_CONTACTS_FIELD, ProjectContact } from './ProjectContactsField'

import { AddressObject } from '@/components/form-components/AddressAutocomplete'
import {
  REQUIRED_TICKETS_FIELD,
  RequiredTicketValue,
} from '@/components/shared-components/RequiredTicketsField'
import config from '@/config/index'
import { convertEnumToString } from '@/utils/index'

import { ProjectStatus, SupportedLocaleCountryCode } from 'types/api.graphql'

export const PUBLIC_PROJECT_URL = `${config.redirectAppUrl}/project?id=`
export const QR_CODE_ROTATION_PARAM = 'project-code'

export const PROJECT_TAB_FILTER_KEY = 'tab'

export enum ProjectTabs {
  info = 'Information',
  documents = 'Documents',
  locations = 'Locations',
  siteTimings = 'Site timings',
  tickets = 'ticket:plural',
  induction = 'siteInduction:labels.siteInductionTitlecase',
}

export const PROJECT_STATUSES_TAG = {
  [ProjectStatus.InProgress]: {
    label: convertEnumToString(ProjectStatus.InProgress),
    value: ProjectStatus.InProgress,
    icon: <IconActivityHeartbeat size={16} />,
    variant: 'success' as const,
  },
  [ProjectStatus.Upcoming]: {
    label: convertEnumToString(ProjectStatus.Upcoming),
    value: ProjectStatus.Upcoming,
    icon: <IconClockHour4 size={16} />,
    variant: 'warning' as const,
  },
  [ProjectStatus.Complete]: {
    label: convertEnumToString(ProjectStatus.Complete),
    value: ProjectStatus.Complete,
    icon: <IconCircleCheck size={16} />,
    variant: 'info' as const,
  },
  [ProjectStatus.Archived]: {
    label: convertEnumToString(ProjectStatus.Archived),
    value: ProjectStatus.Archived,
    icon: <IconTrash size={16} />,
    variant: 'danger' as const,
  },
}

export const QR_TYPES = {
  VIC: 'VIC',
}

export enum QrCodeRotationMode {
  Off = 'Off',
  Auto = 'Auto',
  Manual = 'Manual',
}

export enum Field {
  Address = 'address',
  Name = 'name',
  Status = 'status',
  ProjectAdmins = 'projectAdmins',
  StartDate = 'startDate',
  EndDate = 'endDate',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Radius = 'radius',
  InfoTitle = 'infoTitle',
  InfoSubtitle = 'infoSubtitle',
  InfoDescription = 'infoDescription',
  ProjectNotesEnabled = 'projectNotesEnabled',
  QrCodeRotationMode = 'qrCodeRotationMode',
  QrCodeRotationInterval = 'qrCodeRotationInterval',
  QrCodeRotationMessage = 'qrCodeRotationMessage',
  QrCodeManualProjectCode = 'qrCodeManualProjectCode',
  Timezone = 'timezone',
  Locale = 'locale',
}

export type FormFieldValues = {
  [Field.Address]: AddressObject
  [Field.Name]: string
  [Field.Status]: ProjectStatus
  [Field.ProjectAdmins]: string[]
  [Field.StartDate]: moment.Moment
  [Field.EndDate]: moment.Moment
  [REQUIRED_TICKETS_FIELD]: RequiredTicketValue[]
  [PROJECT_CONTACTS_FIELD]: ProjectContact[]
  [Field.Latitude]: string
  [Field.Longitude]: string
  [Field.Radius]: string
  [Field.InfoTitle]: string
  [Field.InfoSubtitle]: string
  [Field.InfoDescription]: string
  [Field.ProjectNotesEnabled]: boolean
  [Field.QrCodeRotationMode]: QrCodeRotationMode
  [Field.QrCodeRotationInterval]: number
  [Field.QrCodeManualProjectCode]: string
  [Field.Timezone]: string
  [Field.Locale]: SupportedLocaleCountryCode
}

export const rules = {
  name: [
    { required: true, message: 'Please enter the project name' },
  ] as Rule[],
  status: [
    { required: true, message: 'Please select a project status' },
  ] as Rule[],
  address: [
    { required: true, message: 'Please enter the project address' },
  ] as Rule[],
}
